import React from "react";

const formatCurrency = (amount, currency = 'NGN') => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

const InvoiceTable = ({ items, currency, onDeleteItem }) => {
  const calculateItemTotal = (item) => {
    const discountedPrice = Math.max(0, item.price - (item.discount || 0));
    return item.quantity * discountedPrice;
  };

  return (
    <div className="invoice-table mt-4 overflow-x-auto">
      <div className="min-w-full inline-block align-middle">
        <div className="overflow-hidden border border-gray-200 rounded-lg">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-3 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">Item</th>
                <th className="px-2 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">Qty</th>
                <th className="px-2 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">Price</th>
                <th className="px-2 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">Total</th>
                <th className="px-2 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {items.map((item, index) => {
                const hasDiscount = item.discount > 0;
                const itemTotal = calculateItemTotal(item);
                
                return (
                  <tr key={index} className="hover:bg-white">
                    <td className="px-3 py-2">
                      <div className="max-w-[120px]">
                        <p className=" font-medium truncate text-sm" title={item.description}>
                          {item.description}
                        </p>
                        {hasDiscount && (
                          <p className="text-red-600 text-xs mt-1">
                            Disc: -{formatCurrency(item.discount, currency)}
                          </p>
                        )}
                      </div>
                    </td>
                    <td className="px-2 py-2  text-sm">{item.quantity}</td>
                    
                    <td className="px-2 py-2">
                      {hasDiscount ? (
                        <div className="flex flex-col">
                          <span className="text-gray-400 line-through text-xs">
                            {formatCurrency(item.price, currency)}
                          </span>
                          <span className="text-green-600 font-medium text-sm">
                            {formatCurrency(item.price - item.discount, currency)}
                          </span>
                        </div>
                      ) : (
                        <span className=" text-sm">
                          {formatCurrency(item.price, currency)}
                        </span>
                      )}
                    </td>
                    
                    <td className="px-2 py-2 font-medium text-sm">
                      <span className="">
                        {formatCurrency(itemTotal, currency)}
                      </span>
                    </td>
                    
                    <td className="px-2 py-2">
                      <button
                        onClick={() => onDeleteItem(item.id)}
                        className="bg-red-500 hover:bg-red-600 text-white text-xs font-medium px-2 py-1 rounded transition-colors whitespace-nowrap"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                );
              })}
              
              {items.length === 0 && (
                <tr>
                  <td colSpan="5" className="px-3 py-4 text-center text-gray-500 text-sm">
                    No items added yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InvoiceTable;